<template>
  <div v-if="!detailContactStore.loading && !detailContactStore.error && detailContactStore.data">
    <v-list>
      <v-list-item>
        <template #prepend>
          <v-icon>mdi-account</v-icon>
        </template>

          <v-list-item-subtitle>{{ detailContactStore.data.Anrede }}</v-list-item-subtitle>
          <v-list-item-title>{{ detailContactStore.data.fullName }}</v-list-item-title>

      </v-list-item>
      <v-list-item v-if="detailContactStore.data.Abteilung">
        <template #prepend><v-icon></v-icon></template>

          <v-list-item-subtitle>{{ detailContactStore.data.Abteilung }}</v-list-item-subtitle>
          <v-list-item-title
            >{{ detailContactStore.data.Position
            }}{{
              detailContactStore.data.AufgabenGebiet ? ` (${detailContactStore.data.AufgabenGebiet})` : ""
            }}</v-list-item-title
          >

      </v-list-item>
      <v-list-item v-if="detailContactStore.data.AustrittDatum" class="text-error">
        <template #prepend><v-icon></v-icon></template>

          <v-list-item-subtitle>Ausgetreten</v-list-item-subtitle>
          <v-list-item-title>{{
            detailContactStore.data.austrittsDatumParsed?.format("DD.MM.YYYY")
          }}</v-list-item-title>

      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list>
      <v-list-item
        v-if="detailContactStore.data.Strasse"
        link
        :href="`https://maps.google.com/?saddr=My+Location&daddr=${detailContactStore.data.Strasse}, ${detailContactStore.data.Plz} ${detailContactStore.data.Ort}`"
        target="_blank"
      >
        <template #prepend><v-icon>mdi-map-marker</v-icon></template>

          <v-list-item-title>{{ detailContactStore.data.Strasse }}</v-list-item-title>
          <v-list-item-subtitle>{{
            `${detailContactStore.data.Plz} ${detailContactStore.data.Ort}`
          }}</v-list-item-subtitle>

      </v-list-item>
    </v-list>
    <v-divider />
    <v-list>
      <v-list-item v-if="detailContactStore.data.Telefon1" link :href="`tel: '${detailContactStore.data.Telefon1}'`">
        <template #prepend><v-icon>mdi-phone</v-icon></template>

          <v-list-item-title>{{ detailContactStore.data.Telefon1 }}</v-list-item-title>

      </v-list-item>
      <v-list-item v-if="detailContactStore.data.Telefon2" link :href="`tel: '${detailContactStore.data.Telefon2}'`">
        <template #prepend><v-icon>mdi-cellphone</v-icon></template>

          <v-list-item-title>{{ detailContactStore.data.Telefon2 }}</v-list-item-title>

      </v-list-item>
      <v-list-item v-if="detailContactStore.data.Email" link :href="`mailto: '${detailContactStore.data.Email}'`">
        <template #prepend><v-icon>mdi-at</v-icon></template>

          <v-list-item-title>{{ detailContactStore.data.Email }}</v-list-item-title>

      </v-list-item>
      <v-list-item
        v-if="detailContactStore.data.Homepage"
        link
        :href="`https://${detailContactStore.data.Homepage}`"
        target="_blank"
      >
        <template #prepend><v-icon>mdi-web</v-icon></template>

          <v-list-item-title>{{ detailContactStore.data.Homepage }}</v-list-item-title>

      </v-list-item>
    </v-list>
    <v-divider />
    <v-list>
        <v-list-item
          link
          :to="{
            name: 'contact_histories_list',
            params: { id: $route.params.id },
            query: { ansprechpartner_nr: $route.params.contact_id },
          }"
        >
          <template #prepend>
            <v-avatar size="32px" color="primary"
              ><v-icon color="white" size="18px"
                >mdi-file-document-check</v-icon
              ></v-avatar
            >
          </template>

            <v-list-item-title>Kontakte</v-list-item-title>

          <template #append>
            <v-list-item-action>
              <v-icon>mdi-arrow-right</v-icon>
            </v-list-item-action>
          </template>
        </v-list-item>
      </v-list>
    <template v-if="detailContactStore.data.Info1 || detailContactStore.data.Info2">
      <v-divider></v-divider>
      <v-list>
        <v-list-item v-if="detailContactStore.data.Info1">
          <template #prepend><v-icon>mdi-information-outline</v-icon></template>
          <v-list-item-title>{{ detailContactStore.data.Info1 }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="detailContactStore.data.Info2">
          <template #prepend><v-icon>mdi-information-outline</v-icon></template>
          <v-list-item-title>{{ detailContactStore.data.Info2 }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
    <v-btn
      position="fixed"
      style="z-index: 1;"
      icon
      location="right bottom"
      class="ma-3"
      :to="{
        name: 'customer_contact_create',
        params: { id: $route.params.id, contact_id: $route.params.contact_id, name: detailContactStore.data.fullName },
      }"
      color="primary"
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
  </div>
  <Error v-else-if="detailContactStore.error" :module="detailContactStore.$id" />
  <Loading v-else />
</template>

<script setup lang="ts">
import ErrorComp from '@/components/Error.vue';
import LoadingComp from '@/components/Loading.vue';
import {useStorage} from '@/composables/storage';
import useContactDetailStore from '@/store/detailContact';

const detailContactStore = useContactDetailStore();
useStorage(detailContactStore, (contact, route) => (Array.isArray(route?.params.name) ? route?.params.name[0] : route?.params.name) || 'Ansprechpartner',
    (route) => {
      return {
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
        AnsprechpartnerNr: parseInt(Array.isArray(route.params.contact_id) ?
         route.params.contact_id[0] :
         route.params.contact_id),
      };
    });

defineExpose({
  Error: ErrorComp,
  Loading: LoadingComp,
  detailContactStore,
});
</script>
